// theme/presets/textSize.ts — text-size multiplier table.
//
// Each key maps to a numeric multiplier applied to every fontSize token
// (parse the px value → multiply → re-serialise as "${n}px").
// 'md' = 1 (identity; default Signal Glass sizes).

import type { TextSizeKey } from '@/core/models/preferences';

export const TEXT_SIZE_MULTIPLIERS: Record<TextSizeKey, number> = {
  sm: 0.92,
  md: 1,
  lg: 1.12,
  xl: 1.25,
};
